import { render, staticRenderFns } from "./BlockPriceCategoryList.vue?vue&type=template&id=83783fe0&scoped=true"
import script from "./BlockPriceCategoryList.vue?vue&type=script&lang=js"
export * from "./BlockPriceCategoryList.vue?vue&type=script&lang=js"
import style0 from "./BlockPriceCategoryList.vue?vue&type=style&index=0&id=83783fe0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83783fe0",
  null
  
)

export default component.exports